module.exports = __webpack_public_path__ + "img/ExitusUX_Objetive.2c78697e.png";